
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"7","cy":"22","r":"2"}}),_c('circle',{attrs:{"cx":"17","cy":"22","r":"2"}}),_c('path',{attrs:{"d":"M23 3h-2V1a1 1 0 00-2 0v2h-2a1 1 0 000 2h2v2a1 1 0 002 0V5h2a1 1 0 000-2z"}}),_c('path',{attrs:{"d":"M21.771 9.726a.994.994 0 00-1.162.806A3 3 0 0117.657 13H5.418l-.94-8H13a1 1 0 000-2H4.242L4.2 2.648A3 3 0 001.222 0H1a1 1 0 000 2h.222a1 1 0 01.993.883l1.376 11.7A5 5 0 008.557 19H19a1 1 0 000-2H8.557a3 3 0 01-2.829-2h11.929a5 5 0 004.921-4.112 1 1 0 00-.807-1.162z"}})])
          )
        }
      }
    